export default "__VITE_ASSET__D35fY_vg__"